import _ from 'lodash'

const toggleClass = (el) => {
  const container = document.querySelector('#vehicles-model-selector-list-content')
  if (container !== undefined) {
    container.classList.add('vehicle-model-selector__vehicle-grid--show-all')
  }
}

const directive = {
  bind(el) {
    if (el !== undefined) {
      el.addEventListener('click', _.partial(toggleClass, el))
    }
  },
  unbind(el) {
    el.addEventListener('click', _.partial(toggleClass, el))
  }
}

export default directive
